import { useEffect, useState } from "react";
import { baseURL } from "../../../../constants/commonConstants";
import { IEmployeeTrainingVideos } from "../../../../models/staff/employeeTraining";
import { connect, useDispatch } from "react-redux";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setTrainingHelps } from "../../../../store/slices/master/trainingHelpSlice";
import { getTrainingHelps } from "../../../../action/masters/trainingHelpActionCreator";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const TrainingHelpVideo = (props: IEmployeeTrainingVideos) => {
  const { getEmployeeTraingVideos, employeeTrainingVideos, snapShots } = props;
  const [isSingleVideo, setIsSingleVideo] = useState<boolean>(false);
  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.trainingHelp);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getEmployeeTraingVideos(pageBlockId.trainingHelp, limit.six);
    }
  }, [pageBlockData]);

  useEffect(() => {
    employeeTrainingVideos &&
      setIsSingleVideo(employeeTrainingVideos.length <= 1 ? false : true);
  }, [employeeTrainingVideos]);

  useEffect(() => {
    return () => {
      dispatch(setTrainingHelps([]));
    };
  }, []);

  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  const handleNextVideo = () => {
    if (currentVideoIndex < employeeTrainingVideos.length - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
    } else if (currentVideoIndex === employeeTrainingVideos.length - 1) {
      setCurrentVideoIndex(0);
    }
  };

  const handlePreviousVideo = () => {
    if (currentVideoIndex > 0) {
      setCurrentVideoIndex(currentVideoIndex - 1);
    } else if (currentVideoIndex === 0) {
      setCurrentVideoIndex(employeeTrainingVideos.length - 1);
    }
  };

  const playVideo = (videoUrl: string) => {
    window.open(videoUrl, "_blank");
  };

  return (
    <>
      <div className="col-lg-12 ">
        <div
          className={
            pageBlockData?.displayOrNot
              ? "card-wrap"
              : "card-wrap card-snapshot"
          }
          style={
            pageBlockData?.displayOrNot === false
              ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
              : {}
          }
        >
          <div className="title mb-28">
            <h2 className="mt-28">Training Help</h2>
            {employeeTrainingVideos && employeeTrainingVideos?.length > 0 && (
              <div
                className={
                  pageBlockData?.displayOrNot
                    ? "btn-arrow-wrap"
                    : "btn-arrow-wrap d-none"
                }
              >
                {isSingleVideo && (
                  <>
                    <button
                      id="prev-week"
                      className="btn-arrow"
                      onClick={handlePreviousVideo}
                    >
                      <i className="fa-solid fa-angle-left"></i>
                    </button>
                    <button
                      id="next-week"
                      className="btn-arrow"
                      onClick={handleNextVideo}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
          {employeeTrainingVideos && employeeTrainingVideos.length > 0 && (
            <div
              className={
                pageBlockData?.displayOrNot
                  ? "training-help mt-2 mb-4"
                  : "training-help mt-2 mb-4 d-none"
              }
            >
              <div className="img">
                <img
                  src={
                    employeeTrainingVideos &&
                    baseURL + employeeTrainingVideos[currentVideoIndex]?.image
                  }
                  alt=""
                />
              </div>
              <a
                id="play-video"
                className="btn-video"
                title="Play Video"
                onClick={() =>
                  playVideo(
                    employeeTrainingVideos[currentVideoIndex]?.videoLink
                  )
                }
              >
                <span></span>
              </a>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getEmployeeTraingVideos: (pageBlock?: number, noOfItems?: number) =>
    getTrainingHelps(pageBlock, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    employeeTrainingVideos: state.trainingHelp.trainingHelps,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingHelpVideo);
